import { render, staticRenderFns } from "./linkExpired.vue?vue&type=template&id=409ecf4e&scoped=true"
import script from "./linkExpired.vue?vue&type=script&lang=js"
export * from "./linkExpired.vue?vue&type=script&lang=js"
import style0 from "./linkExpired.vue?vue&type=style&index=0&id=409ecf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409ecf4e",
  null
  
)

export default component.exports